import { useEffect } from "react";

/**
 * useBodyScrollLock — блокує скрол фону поки відкритий попап/оверлей
 * (юзер 2026-06-27: «під попапом задній фон все одно листається»).
 * Викликати в кореневому компоненті будь-якого модала.
 */
export function useBodyScrollLock(active: boolean = true): void {
  useEffect(() => {
    if (!active) return;
    const body = document.body;
    const html = document.documentElement;
    const prevBody = body.style.overflow;
    const prevHtml = html.style.overflow;
    body.style.overflow = "hidden";
    html.style.overflow = "hidden";
    return () => {
      body.style.overflow = prevBody;
      html.style.overflow = prevHtml;
    };
  }, [active]);
}
